import { ClipboardList } from "lucide-react";

export const PreLogisticsPanel = () => (
  <section className="bg-slate-900 border border-dashed border-slate-700 rounded-lg p-4" data-testid="prelogistics-panel">
    <div className="flex items-center gap-2">
      <ClipboardList className="h-5 w-5 text-slate-400" />
      <h3 className="font-semibold">Prelogistica</h3>
      <span className="ml-auto text-xs uppercase tracking-wider text-slate-500 border border-slate-700 rounded-full px-2 py-0.5">In arrivo</span>
    </div>
    <p className="text-sm text-slate-500 mt-2">Questa sezione sarà attivata a breve.</p>
  </section>
);
